import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

interface GoogleAdProps {
  format?: 'auto' | 'rectangle' | 'horizontal' | 'vertical';
  slot: string;
  style?: React.CSSProperties;
  responsive?: boolean;
  className?: string;
}

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

const GoogleAd: React.FC<GoogleAdProps> = ({ 
  format = 'auto', 
  slot, 
  style = {}, 
  responsive = true,
  className = ''
}) => {
  const adRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    try {
      // Skip if window.adsbygoogle is not defined (e.g. AdBlocker is installed)
      if (window.adsbygoogle && adRef.current) {
        // Push ad to Google AdSense
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (error) {
      console.error('Error initializing AdSense ad:', error);
    }
  }, []);

  return (
    <Box
      className={`adsbygoogle ${className}`}
      ref={adRef}
      sx={{
        display: 'block',
        textAlign: 'center',
        overflow: 'hidden',
        width: '100%',
        margin: '20px auto',
        borderRadius: '8px',
        ...style
      }}
      data-ad-client="ca-pub-9404609583356876"
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive ? 'true' : 'false'}
    />
  );
};

export default GoogleAd; 